export default __webpack_public_path__ + "confirmation_image.52a24c.svg";